import { http, httpAuth } from "../utils/axios";

const featureFlagRequests = {
  get_all_targetted_feature_flags: function ({ data, options }) {
    let conf = {
      data,
      method: "post",
      preventAllErrorToast: true,
      url: "/v1/feature_flag/private",
      ...options,
    };

    return httpAuth(conf);
  },
  get_feature_flag_set: function ({ data, options }) {
    let conf = {
      data,
      method: "post",
      preventAllErrorToast: true,
      url: "/v1/feature_flag/public",
      ...options,
    };

    return http(conf);
  },
  post_feature_flag_error: function ({ data, options }) {
    let conf = {
      data,
      method: "post",
      url: "/v1/feature_flag/error",
      ...options,
    };

    return httpAuth(conf);
  },
};

export default featureFlagRequests;
